<template>
    <div class="c-form-item" :class="[ customClass ? customClass : '', horizontal ? 'c-form-item--horizontal' : '', fluid ? 'c-form-item--fluid':'', localError ? 'c-form-item--error':'', inputSize ? `c-form-item--${inputSize}`: '']">
        <v-label :custom-class="[customLabelClass ? customLabelClass : '']" :id="name" v-if="hasSlotData('label')">
            <slot name="label"></slot>
        </v-label>
        <div class="u-inline-block u-pos-relative" :class="{'u-fullwidth': fluid}">
            <div class="u-flex-set u-flex--align-items-baseline c-input-wrapper-flex">
                <div class="[ c-input-parent ] u-pos-relative" :class="[!width ? 'u-fullwidth':'']" :style="`width: ${width}`">
                    <input class="c-form-element c-input u-fullwidth"
                           :class="`${customInputClass ? customInputClass : ''} ${inputSize ? `c-input--${inputSize} u-font-${inputSize}`:''} ${inputClass ? inputClass : ''}`"
                           :size="size"
                           :disabled="disabled"
                           :type="type ? (type == 'integer' ? 'number' : type) : 'text'"
                           :max="max"
                           :min="min"
                           :step="step"
                           :name="name"
                           :id="name"
                           :autocomplete="autocomplete"
                           :aria-expanded="ariaExpanded"
                           :maxlength="maxlength"
                           @input="change"
                           :placeholder="placeholder"
                           v-model="localValue"
                           v-debounce="debounceDelay"
                           @focus="focus"
                           @blur="blur"
                           @keyup.enter="$emit('enter')"
                           @keydown="checkInteger"
                    >
                    <slot name="dropdown"></slot>
                </div>
                <v-error v-if="localError">
                    <slot name="error">{{ localError }}</slot>
                </v-error>
                <span class="u-margin-left-tiny" :class="`${inputSize ? `u-font-${inputSize}`:''}`" v-if="hasSlotData('suffix')">
                <slot name="suffix"></slot>
            </span>
            </div>
            <div v-if="localWarning" class="c-input-warning u-font-small">
                {{ localWarning }}
                <div class="arrow-down"></div>
            </div>
        </div>
        <div class="u-inline-block u-pos-relative button-slot">
            <slot name="button"></slot>
        </div>        
    </div>
</template>

<script>
    import VLabel from './Label.vue'
    import VError from './Error.vue'
    import debounce from 'v-debounce'

    export default {
        props: {
            'name': String,
            'disabled': Boolean,
            'custom-class': String,
            'custom-label-class': String,
            'custom-input-class': String,
            'fluid': {type: Boolean, default: false},
            'type': String,
            'value': {type: [String, Number], default: ''},
            'max': Number,
            'min': Number,
            'step': String,
            'input-size': String,
            'size': String,
            'error': String,
            'horizontal': {type: Boolean, default: true},
            'maxlength': {type: Number, default: 524288},
            'width': String,
            'autocomplete': String,
            'aria-expanded': String,
            'debounce-delay': {type: Number, default: 1},
            'placeholder': String,
            'input-class': String
        },
        components: {
            VLabel,
            VError
        },
        data() {
            return {
                localValue: this.value,
                localError: this.error,
                localWarning: null
            };
        },
        mounted() {
            if (typeof this.name === "undefined") {
                console.warn(`You are missing a name attribute`);
            }
        },
        watch: {
            error() {
                this.localError = this.error;
            },
            value() {
                switch (this.type) {
                    case 'number':
                      this.localValue = this.checkMaximumValue(this.value);
                      break;
                    case 'integer':
                      this.localValue = ~~this.checkMaximumValue(this.value);
                      break;
                    default:
                      this.localValue = this.value;
                      break;
                }
            },
            localValue(value) {
                this.updateValue(value);
            }
        },
        methods: {
            hasSlotData(name) {
                if (name) {
                    return this.$slots[name];
                }
                return this.$slots.default;
            },
            focus(value) {
                this.$emit('focus', value);
            },
            blur(value) {
                this.$emit('blur', value);
            },
            checkInteger(event) {
                if (this.type === 'integer') {
                    return (event.charCode !== 188 && event.charCode !== 190);
                }
                return true;
            },
            change(value) {
                this.$emit('change', value);
            },
            updateValue(value) {
                this.$emit('input', value);
            },
            checkMaximumValue(value) {
                if(value > this.max){
                    this.localWarning = 'Value higher than ' + this.max;
                    value = this.max;
                    setTimeout(() => {
                        this.localWarning = null;
                    }, 2000);
                }

                return value;
            }
         

        },
        directives: {debounce}
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";

    .c-input-warning {
        position: absolute;
        top: -45px;
        left: -80px;
        width: 160px;
        padding: 0.5em;
        background-color: $color-beta;
        color: $color-base;
        z-index: 10;
    }

    .arrow-down {
        position: absolute;
        bottom: -8px;
        left: 50%;
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid $color-beta;
    }
    .is-ie11 .c-product-size .c-input-wrapper-flex {
      display: inline-block !important;
    }

    .button-slot{
        margin-left:0.4em;
    }
</style>



// WEBPACK FOOTER //
// src/components/form/Input.vue